import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakPoints;

const S = {};

S.Devices = styled.section`
  label: Devices;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

S.Devices.Header = styled.div`
  label: Header;

  padding: 0 1.25rem;

  @media (${widthSmall}) {
    max-width: 42.5rem;
    padding: 0 2.5rem;
  }
`;

S.Devices.HeaderTitle = styled.h2`
  label: HeaderTitle;

  margin-bottom: 0.5rem;
`;

S.Devices.HeaderSubtitle = styled.h3`
  label: HeaderSubtitle;

  color: var(--colors-scarpa-flow);
  margin-bottom: 1.5rem;
`;

S.Devices.ImageHolder = styled.div`
  label: ImageHolder;

  z-index: var(--z-index-under-background);
  height: 20rem;

  @media (${widthSmall}) {
    margin-top: -2.6rem;
    height: 32rem;
  }

  @media (${widthMedium}) {
    margin-top: -5.625rem;
    height: 46.5625rem;
  }
`;

S.Devices.Image = styled.img`
  label: Image;

  display: block;
  height: 100%;
`;

export default S;
